<md-confirm-popup
  data-test="DnzSuhnM"
  [dialogData]="data"
  [forceDisabled]="(disabled$ | async)!"
  (confirmed)="confirm()"
  (canceled)="cancel()"
  (closed)="close()"
  [canCloseDialog]="false"
>
  <div data-test="zEh76cgE" class="form-group__field" [class.error]="message.invalid">
    <textarea
      data-test="3p7_hCg1"
      *ngIf="data.useTextarea; else textInput"
      [placeholder]="data.placeholder || ''"
      [formControl]="message"
      class="input"
    ></textarea>
    <ng-template #textInput>
      <input
        data-test="KNhm-ADP"
        class="input input_sm"
        id="invoice-name-input"
        [placeholder]="data.placeholder || ''"
        [formControl]="message"
      />
    </ng-template>
  </div>
</md-confirm-popup>
